<template>
  <div id="app">
    <basic-layout>
      <template #header>
        <nav v-if="showNav" id="nav">
          <router-link to="/">Home</router-link> |
          <router-link to="/about">About</router-link>
        </nav>
      </template>

      <router-view />
    </basic-layout>
  </div>
</template>

<script>
import BasicLayout from '@/layouts/BasicLayout.vue'

export default {
  name: 'App',
  components: {
    BasicLayout
  },

  data() {
    return {
      showNav: false // 控制导航显示
    }
  },
  mounted() {
    //获取window 来源referrer 
    const referrer = document.referrer;
    if (referrer) {
      localStorage.setItem('referrer', referrer);
    }
    //获取referrer的参数
  }
}
</script>

<style lang="scss">
@import './styles/fonts.scss';
@import './styles/common.scss';
</style>
